module.exports = __webpack_public_path__ + "static/media/banner-garantia-desktop.8d929d45.webp";